module.exports = __webpack_public_path__ + "img/logo_admin.df2c57a0.png";